var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttendance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-attendance"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "attendance",
    clipPath: "url(#clip-attendance)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15834",
    "data-name": "Group 15834",
    transform: "translate(1253.893 -20626.025)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9378",
    "data-name": "Group 9378",
    transform: "translate(-1253.432 20627)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "calendar_2_",
    "data-name": "calendar(2)",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18546",
    "data-name": "Path 18546",
    d: "M26.926,2.415H24.149V.966a.966.966,0,1,0-1.932,0V2.415H8.694V.966a.966.966,0,1,0-1.932,0V2.415H3.985A3.989,3.989,0,0,0,0,6.4V26.926a3.989,3.989,0,0,0,3.985,3.985H26.926a3.989,3.989,0,0,0,3.985-3.985V6.4A3.989,3.989,0,0,0,26.926,2.415ZM3.985,4.347H6.762v.966a.966.966,0,1,0,1.932,0V4.347H22.217v.966a.966.966,0,1,0,1.932,0V4.347h2.777A2.055,2.055,0,0,1,28.979,6.4V8.694H1.932V6.4A2.055,2.055,0,0,1,3.985,4.347ZM26.926,28.979H3.985a2.055,2.055,0,0,1-2.053-2.053v-16.3H28.979v16.3A2.055,2.055,0,0,1,26.926,28.979Z",
    fill: "#5c6d7e",
    stroke: "#5c6d7e",
    strokeWidth: 0.28
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9381",
    "data-name": "Group 9381",
    transform: "translate(-1246.504 20641.131)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25244",
    "data-name": "Rectangle 25244",
    width: 6.056,
    height: 2.965,
    rx: 1.482,
    fill: "#5c6d7e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25247",
    "data-name": "Rectangle 25247",
    width: 6.056,
    height: 2.965,
    rx: 1.482,
    transform: "translate(0 8.075)",
    fill: "#5c6d7e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25245",
    "data-name": "Rectangle 25245",
    width: 6.056,
    height: 2.965,
    rx: 1.482,
    transform: "translate(10.093)",
    fill: "#5c6d7e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25246",
    "data-name": "Rectangle 25246",
    width: 6.056,
    height: 2.965,
    rx: 1.482,
    transform: "translate(10.093 8.075)",
    fill: "#5c6d7e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9379",
    "data-name": "Group 9379",
    transform: "translate(-1235.106 20643.252)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1183",
    "data-name": "Ellipse 1183",
    cx: 10.093,
    cy: 10.093,
    r: 10.093,
    fill: "#fff",
    stroke: "#5c6d7e",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21166",
    "data-name": "Path 21166",
    d: "M64.121,629.828l-4.764,4.764-1.736-1.736a.757.757,0,0,0-1.07,1.07l2.271,2.271a.755.755,0,0,0,1.07,0l5.3-5.3a.756.756,0,0,0-1.07-1.07Z",
    transform: "translate(-50.914 -622.43)",
    fill: "#5c6d7e"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttendance);
export default __webpack_public_path__ + "static/media/attendance.4c2d41ba9d996f9edeb2598eae39b651.svg";
export { ForwardRef as ReactComponent };